import axios from "axios";
import { commonInterceptor } from "../Common/interceptor";

const API_URL = process.env.REACT_APP_API_BASE_URL;

const FormDataService = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

FormDataService.interceptors.request.use(commonInterceptor);

export default FormDataService;
